import React from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";

import { Box, Button, ErrorMsg, Grid, Text } from "atoms";
import { FormInput } from "molecules/FormInput";

const validationSchema = Yup.object().shape({
  newPassword: Yup.string()
    .required("Password is required")
    .min(7, "Password too short")
    .max(20, "Password too long")
    .matches(/^(?=.*[a-z])/, "Must contain at least one lowercase character")
    .matches(/^(?=.*[A-Z])/, "Must contain at least one uppercase character")
    .matches(/^(?=.*[0-9])/, "Must contain at least one number")
    .matches(
      /^(?=.*[!@#$%^&*?~`])/,
      "Must contain at least one special character"
    ),
  confirmPassword: Yup.string().required(),
});

export const ResetPasswordForm = ({ onSubmit, loading, error, resetError }) => {
  return (
    <Box>
      <Text
        fontSize="2rem"
        color="primary.900"
        fontFamily="NeometricBold"
        mb="2rem"
      >
        Reset Password
      </Text>

      <Formik
        initialValues={{
          newPassword: "",
          confirmPassword: "",
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ setFieldValue }) => {
          return (
            <Form>
              <Grid gridGap="2.4rem">
                <FormInput
                  name="newPassword"
                  type="password"
                  placeholder="New Password"
                  onChange={(e) => {
                    setFieldValue("newPassword", e?.target?.value);
                    error && resetError();
                  }}
                />
                <FormInput
                  name="confirmPassword"
                  type="password"
                  placeholder="Confirm Password"
                  onChange={(e) => {
                    setFieldValue("confirmPassword", e?.target?.value);
                    error && resetError();
                  }}
                />
                {error && <ErrorMsg text={error} />}
                <Button
                  my="2rem"
                  width="100%"
                  variant="primary"
                  height="4.8rem"
                  type="submit"
                  loading={loading}
                >
                  Submit
                </Button>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};
